import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';

import { finalize } from 'rxjs';
import { CountryCode } from 'libphonenumber-js';

import { Location } from '@shared/location/models';
import { getCustomFieldNameIdMap, getEnabledCustomFieldNames } from '@shared/party';
import {
  ConfirmationModalRef,
  ConfirmationModalService,
  IParty,
  TelService,
} from '@tablesready/common-ui';
import { ImportService } from '../../services';
import { catchError, of, take, tap } from 'rxjs';

@Component({
  selector: 'tablesready-import-list',
  styleUrls: ['./import-list.component.scss'],
  templateUrl: './import-list.component.html',
})
export class ImportListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() location: Location;
  @Input() parties: (IParty & {selected: boolean;})[] = [];
  @Output() onCancel = new EventEmitter<[]>()

  selection = this.formBuilder.array([]);
  submitting = false;
  disableSubmit = false;
  sendConfirmation = false;
  nameIdMap: Record<string, unknown> = {};
  customFieldNames: string[] = [];

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly confirmationModalService: ConfirmationModalService,
    private readonly importService: ImportService,
    private readonly telService: TelService,
  ) {
  }

  ngOnInit(): void {
    this.nameIdMap = getCustomFieldNameIdMap(this.location.partyFields);
    this.customFieldNames = getEnabledCustomFieldNames(this.location.partyFields);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.parties.currentValue) {
      for (let index = 0; index < changes.parties.currentValue.length; index++) {
        this.selection.insert(index, new UntypedFormControl(true, [Validators.required]));
      }
    }
  }

  ngOnDestroy(): void {
    this.onCancel.complete();
    this.selection.clear();
  }

  save() {
    if (this.submitting) {
      return;
    }

    const parties: any[] = [];
    for (let index = 0; index < this.selection.value.length; index++) {
      if (this.selection.value[index]) {
        const {selected, ...party} = this.parties[index];
        const formattedPhone = this.telService.format(party.phone, this.location.country as CountryCode, 'intl');
        party.phone = formattedPhone;
        parties.push(party);
      }
    }

    if (parties.length) {
      this.importService.saveBulk(parties, this.sendConfirmation)
        .pipe(finalize(() => this.submitting = false))
        .subscribe();
    }
  }

  cancel() {
    this.onCancel.emit([]);
  }

  changeSelection() {
    this.disableSubmit = this.selection.value.filter(value => value).length === 0;
  }

  confirmSendSms(event: MouseEvent) {
    if (this.sendConfirmation) {
      this.sendConfirmation = false;

      return;
    }

    event.preventDefault();
    this.confirmationModalService.confirm({
      content: `Are you sure you want to SMS every selected
        ${this.location.displayOptions?.labels?.reservation || 'reservation'}?`,
    })
      .pipe(
        take(1),
        tap((result) => {
          this.sendConfirmation = result.isConfirmed;
        }),
      )
      .subscribe();
  }

  trackBy(index: number) {
    return index;
  }
}
